// @ts-nocheck
import { MODULE_ACL, USER_ROLES } from "./constant";
import { isAclModuleOptionsRelevant } from "./aclModuleOptionsAccess";
import { parseModuleOperations } from "./voicePlanAcl";

export const CALL_CENTRE_ACL_MODULE = MODULE_ACL.CALL_CENTRE;
export const TRANSCRIPTION_ACL_OPTION = "transcription";

function isSuperAdminRole(userRole, isSuperAdmin) {
  return isSuperAdmin || userRole === USER_ROLES.SUPERADMIN;
}

export function getCallCentreAclEntry(moduleOperations) {
  const ops = parseModuleOperations(moduleOperations);
  return ops[CALL_CENTRE_ACL_MODULE] || null;
}

export function normalizeCallCentreTranscriptionOptions(options) {
  if (!Array.isArray(options)) return [];
  return [
    ...new Set(
      options
        .map((o) => String(o).trim())
        .filter((o) => o === TRANSCRIPTION_ACL_OPTION)
    ),
  ];
}

export function hasCallCentreTranscriptionAcl(
  moduleOperations,
  { userRole = null, isSuperAdmin = false } = {}
) {
  if (isSuperAdminRole(userRole, isSuperAdmin)) {
    return true;
  }

  const entry = getCallCentreAclEntry(moduleOperations);
  if (!entry?.edit && !entry?.add) {
    return false;
  }

  // Legacy ACLs (before transcription options): no edit_options field → all options allowed.
  if (!Array.isArray(entry.edit_options)) {
    return true;
  }

  return normalizeCallCentreTranscriptionOptions(entry.edit_options).includes(
    TRANSCRIPTION_ACL_OPTION
  );
}

export function isCallCentreTranscriptionEnabled(callCentre) {
  if (!callCentre) return false;
  return (
    callCentre.is_transcription_enabled === true ||
    callCentre.is_transcription_enabled === 1
  );
}

/* See canManageChildVoicemail — child enablement follows the call centre's
 * capability; the Call Centres List ACL only gates the call centre itself. */
export function canManageChildTranscription(callCentre) {
  return isCallCentreTranscriptionEnabled(callCentre);
}

export function getParentGrantableCallCentreTranscription(moduleOperations, isSuperAdmin) {
  if (isSuperAdmin) {
    return { canGrantTranscription: true };
  }
  const entry = getCallCentreAclEntry(moduleOperations);
  if (!entry?.add && !entry?.edit) {
    return { canGrantTranscription: false };
  }
  if (!Array.isArray(entry?.edit_options)) {
    return { canGrantTranscription: true };
  }
  return {
    canGrantTranscription: normalizeCallCentreTranscriptionOptions(entry.edit_options).includes(
      TRANSCRIPTION_ACL_OPTION
    ),
  };
}

export function normalizeCallCentreTranscriptionAclForSave(
  { edit_options = [] } = {},
  parentGrantable = null
) {
  let options = normalizeCallCentreTranscriptionOptions(edit_options);
  if (parentGrantable && !parentGrantable.canGrantTranscription) {
    options = [];
  }
  return { edit_options: options };
}

export function formatCallCentreTranscriptionAclLabel(moduleEntry) {
  if (!isAclModuleOptionsRelevant(moduleEntry)) return "—";
  const options = normalizeCallCentreTranscriptionOptions(moduleEntry.edit_options);
  if (options.length === 0) return "—";
  if (!options.includes(TRANSCRIPTION_ACL_OPTION)) return "—";
  return "Transcription";
}

export function getUserModuleOperations(user) {
  if (!user) return {};
  const raw =
    user?.acl_settings?.module_operations ?? user?.module_operations ?? null;
  return parseModuleOperations(raw);
}

export function readTranscriptionEnabled(record) {
  if (!record) return false;
  return (
    record.is_transcription_enabled === true ||
    record.is_transcription_enabled === 1
  );
}
